module.exports = "<atn-datagrid-header\r\n  [name]=\"name\"\r\n></atn-datagrid-header>\r\n\r\n<atn-datagrid-filters>\r\n  <ng-content></ng-content>  \r\n</atn-datagrid-filters>\r\n\r\n<atn-datagrid-table\r\n  [columns]=\"columns\"\r\n  [data]=\"data\"\r\n  [filters]=\"filters\"\r\n></atn-datagrid-table>"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms/src/datagrid/datagrid.component.html
// module id = ./libs/atenea-cms/src/datagrid/datagrid.component.html
// module chunks = main